<div class="alert_wrap">
    <!--그룹 플레이 로딩-->
    <div class="group_con" *ngIf="alertData">
        <div class="txt_area">
            <p>{{ message }}</p>
        </div>
    </div>
</div>